export default __webpack_public_path__ + "static/media/closet5-before2-768w.26b849f1.png";